'use client';

import * as React from 'react';
import { SIDEBAR_COLLAPSE_BREAKPOINT } from './constants';

/**
 * `useIsNavCollapsed` — true when the viewport is narrow enough that the global
 * left nav should auto-collapse into the mobile drawer (below
 * `SIDEBAR_COLLAPSE_BREAKPOINT`, i.e. Tailwind's `lg`/1024px).
 *
 * Deliberately sidebar-scoped rather than reusing the shared `useIsMobile`
 * hook (lib/use-mobile.tsx, 1280px): that hook also drives layout decisions in
 * file-upload, inline-tabs, the account header and team-members card, so the
 * nav's collapse threshold must be tuned independently of theirs.
 *
 * Pattern mirrors `lib/use-mobile.tsx` so the SSR snapshot is stable: defaults
 * to expanded (desktop) on the server; a narrow client sees a brief desktop
 * frame on first paint which `useSyncExternalStore` corrects on hydration.
 */
function subscribe(callback: () => void) {
  const mql = window.matchMedia(
    `(max-width: ${SIDEBAR_COLLAPSE_BREAKPOINT - 1}px)`
  );
  mql.addEventListener('change', callback);
  return () => mql.removeEventListener('change', callback);
}

function getSnapshot() {
  return window.innerWidth < SIDEBAR_COLLAPSE_BREAKPOINT;
}

function getServerSnapshot() {
  return false;
}

export function useIsNavCollapsed() {
  return React.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
